import { useEffect } from 'react';

export const useAutoSaveCalculations = (calculations, setFormData) => {
  useEffect(() => {
    // Mettre à jour les calculs dans le formulaire
    setFormData(prevFormData => {
      // Vérifier s'il y a des changements avant de mettre à jour
      const hasChanges = Object.keys(calculations).some(
        key => prevFormData[key] !== calculations[key]
      );

      if (hasChanges) {
        return {
          ...prevFormData,
          ...calculations,
        };
      }

      return prevFormData;
    });
  }, [calculations, setFormData]);
};
